import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Assalamu alaikum, ${u.name?.split(" ")[0]}`);
      nav(["admin", "moderator", "super_admin"].includes(u.role) ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-[820px] mx-auto px-6 md:px-10 py-24" data-testid="login-page">
      <div className="max-w-md w-full mx-auto text-center">
        <div className="label-eyebrow text-brand-terracotta">Sign in</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-3 text-brand-ink tracking-tighter">Enter your world.</h1>
        <p className="mt-4 text-brand-muted">Access your dossier, matches, and conversations.</p>
      </div>

      <form onSubmit={onSubmit} className="mt-14 max-w-md mx-auto space-y-6">
        <div>
          <Label htmlFor="email" className="label-eyebrow text-brand-muted">Email</Label>
          <Input
            id="email" type="email" required value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            className="mt-2 h-14 rounded-none border-0 border-b border-brand-line bg-transparent px-0 focus-visible:ring-0 focus-visible:border-brand-terracotta"
            placeholder="you@family.com"
          />
        </div>
        <div>
          <Label htmlFor="password" className="label-eyebrow text-brand-muted">Password</Label>
          <Input
            id="password" type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            className="mt-2 h-14 rounded-none border-0 border-b border-brand-line bg-transparent px-0 focus-visible:ring-0 focus-visible:border-brand-terracotta"
            placeholder="••••••••"
          />
        </div>
        <Button
          type="submit" disabled={loading}
          data-testid="login-submit-btn"
          className="w-full h-14 rounded-full bg-brand-terracotta hover:bg-brand-terracotta/90 text-white"
        >
          {loading ? "Signing in…" : "Sign In"}
        </Button>
      </form>

      <p className="mt-8 text-sm text-brand-muted text-center">
        New here?{" "}
        <Link to="/register" className="text-brand-terracotta underline underline-offset-4">
          Create your profile
        </Link>
      </p>
    </div>
  );
}
